import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import englishResources from "./locales/en/resources.json";
import spanishResources from "./locales/es/resources.json";

const supportedLanguages = ["es", "en"];
const storedLanguage = globalThis.localStorage?.getItem("language");
const browserLanguage = globalThis.navigator?.language?.split("-")[0];
const initialLanguage = supportedLanguages.includes(storedLanguage)
  ? storedLanguage
  : supportedLanguages.includes(browserLanguage)
    ? browserLanguage
    : "es";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: spanishResources },
      en: { translation: englishResources },
    },
    lng: initialLanguage,
    fallbackLng: "es",
    supportedLngs: supportedLanguages,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
